<template>
  <mdb-container fluid class="gp-has-header">
    <div>
      <data-table ref="subs"
                  :actions="actions"
                  @handleAction="handleRowAction"
                  queryName="SystemSubscription"
                  page-title="Subscription Information"
                  title-icon="money-bill-wave-alt"
      />
    </div>

  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTableAdvanced'

import {mdbContainer} from 'mdbvue';

export default {
  name: 'subscriptions',
  components: {
    mdbContainer,
    dataTable
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  data() {
    return {

      actions: [
        {name: "select", label: "View/Edit Subscription", color:"success", icon:"pencil"},
        {name: "pm", label: "Private Message", color: "success", icon: "envelope"},
        {name: "user", label: "User Details", color: "success", icon: "user-edit"}
      ],
    }
  },
  mounted() {
    if (this.userDetails.isAdmin) {
      this.actions.push({name: "proxy", label: "Proxy User", color: "success", icon: "user-ninja"})
    }

  },
  methods: {
    showUser(user) {
      this.$router.push("/admin/subscription/" + user.subscriptionId + "?return=/user/subscription")
    },
    handleRowAction(row,action) {
      if (action == "select") this.showUser(row)
      if (action == "pm") {
        this.$router.push('/conversations?start='+row.userId)
      }
      if (action == "proxy") this.$router.push("/users/" + row.userId + "/proxy")
      if (action == "user") this.$router.push("/users/" + row.userId )
    }


  }

}
;
</script>
